import {
    PenLine,
    AudioLines,
    Languages,
    BookOpen,
    HeartHandshake,
    Compass,
    BedDouble,
    MoonStar,
    Landmark,
    School,
    Store,
    UtensilsCrossed,
    Users,
    ShieldCheck,
    Star,
    Youtube,
    Facebook,
    Instagram,
    MessageCircle,
    Dumbbell,
    LibraryBig,
} from "lucide-react";

export const SITE = {
    name: "PPTQ Baitul Haq",
    fullName: "PPTQ Baitul Haq Trenggalek",
    location: "Trenggalek, Jawa Timur",
    type: "Pondok Pesantren Tahfidz",
    subtitle: "Pesantren Tahfidz & Pembinaan Adab Qurani",
    tagline: "Mencetak Generasi Qurani Pemimpin Peradaban",
    nsp: "510235030083",
};

export const LINKS = {
    googleForm: "https://forms.gle/YFmCVWxzi6FNkAfq6",
    whatsappDisplay: "+62 821-3934-6623",
    whatsapp:
        "https://api.whatsapp.com/send/?phone=6282139346623",
    whatsappChat:
        "https://api.whatsapp.com/send/?phone=6282139346623&text=" +
        encodeURIComponent(
            "Bismillah, Saya wali dari calon santri. Saya ingin menanyakan prosedur pendaftaran di PPTQ Baitul Haq Trenggalek. Mohon informasinya, terima kasih."
        ),
    maps: "https://maps.app.goo.gl/2q4M4aC7GAbGcJHm6",
    mapsEmbed:
        "https://www.google.com/maps?q=-8.1172167,111.7519064&z=17&output=embed",
    email: "Info@baitulhaq.com",
};

export const NAV = [
    { label: "Beranda", href: "#beranda", id: "beranda" },
    { label: "Tentang", href: "#tentang", id: "tentang" },
    { label: "Program", href: "#program", id: "program" },
    { label: "Pendidikan", href: "#pendidikan", id: "pendidikan" },
    { label: "Fasilitas", href: "#fasilitas", id: "fasilitas" },
    { label: "Galeri", href: "#galeri", id: "galeri" },
    { label: "Kontak", href: "#kontak", id: "kontak" },
];

export const HERO = {
    eyebrow: "Pondok Pesantren Tahfidhul Qur'an di Trenggalek Jawa Timur",
    headline: "Mencetak Generasi Qurani yang Memimpin Peradaban",
    subheadline:
        "Pondok Pesantren di Trenggalek yang berfokus pada Tahfidzul Qur’an 30 Juz Mutqin, Sanad Al-Qur’an, dan Pembinaan Adab Qurani.",
    primaryCta: "Daftar Sekarang",
    secondaryCta: "Kenali Program Kami",
    pills: ["30 Juz Mutqin", "Sanad Al-Qur’an", "Pembinaan Adab Qurani", "SMP & SMA"],
};

export const MARQUEE_ITEMS = [
    "30 Juz",
    "Mutqin",
    "Bersanad",
    "Tahsin",
    "Tahfidz",
    "Sanad Al-Qur’an",
    "Adab Qurani",
];

export const FOCUS = {
    eyebrow: "Tujuan Utama",
    title: "Fokus Pendidikan Kami",
    sub: "Al-Qur’an menjadi inti perjalanan pendidikan santri menuju hafalan yang mutqin dan bersanad.",
    items: [
        {
            number: "01",
            title: "30 Juz",
            description: "Target hafalan Al-Qur’an 30 Juz.",
        },
        {
            number: "02",
            title: "Mutqin",
            description:
                "Hafalan yang dijaga kualitas dan kekuatannya melalui muroja’ah dan pembinaan.",
        },
        {
            number: "03",
            title: "Bersanad",
            description:
                "Pembacaan Al-Qur’an secara mutqin untuk mendapatkan sanad guru-guru Al-Qur’an yang bersambung sampai Rasulullah SAW.",
        },
    ],
};

export const ABOUT = {
    eyebrow: "Tentang",
    title: "Mengenal PPTQ Baitul Haq",
    statement: [
        {
            text: "PPTQ Baitul Haq adalah lembaga pendidikan yang berfokus pada pembentukan penghafal Al-Qur'an 30 Juz Mutqin dan Bersanad.",
            bold: true,
        },
        {
            text: " Program Tahsin, Tahfidz, dan Sanad menjadi inti pembinaan yang diintegrasikan dengan Qiro'atul Qur'an, Bahasa Arab, Ulumul Syar'i, Akhlak & Adab, serta Pembinaan Karakter. Jenjang pendidikan SMP dan SMA menjadi bagian pendukung dalam perjalanan pendidikan santri. ",
            bold: false,
        },
        {
            text: "Strategi pendidikan kami dirancang secara terpadu untuk membimbing santri menjadi generasi Qur'ani yang mutqin hafalannya, mulia akhlaknya, dan siap memberi kontribusi nyata bagi umat dan peradaban.",
            bold: true,
            newParagraph: true,
        },
    ],
};

export const VISI_MISI = {
    eyebrow: "Visi & Misi",
    title: "Arah Pendidikan PPTQ Baitul Haq",
    visi: "Menjadi Lembaga Penghasil Para Penghafal Al-qur'an 30 Juz Mutqin Dan Guru Para Penghafal Al-Qur'an Yang Berkepribadian Unggul Sebagai Manusia, Muslim, Mukmin, Muttaqin Yang Siap Memimpin Peradaban.",
    misiIntro:
        "Membimbing Para Santri Berhasil Menjadi Penghafal Al-qur'an 30 Juz Mutqin dan Guru Para Penghafal Al-quran Yang Berkepribadian Unggul sebagai:",
    misiPoints: [
        { icon: Users, text: "Sebaik-baik Manusia" },
        { icon: MoonStar, text: "Sebaik-baik Muslim" },
        { icon: ShieldCheck, text: "Sebaik-baik Mukmin" },
        { icon: Star, text: "Sebaik-baik Muttaqin" },
    ],
    misiOutro:
        "Sesuai Tuntunan Allah dan Rasullullah Sehingga Siap Memimpin Peradaban.",
};

export const STRUCTURE = {
    eyebrow: "Kelembagaan",
    title: "Struktur Kepengurusan",
    sub: "Yayasan Pendidikan Sosial dan Dakwah Baitul Haq",
    supervisors: [
        {
            role: "Pengasuh",
            names: ["Abah H. Hadi Nafian, S.Ag", "Ummi Hj. Titik Ainil Indah, S.Ag"],
        },
        {
            role: "Pembina",
            names: ["Ust. Drs. Agus Sukoco"],
        },
    ],
    chair: {
        role: "Ketua Yayasan",
        names: ["Usth. Nala Luffa Sahila, S.Pd"],
    },
    executives: [
        {
            role: "Sekretaris",
            names: ["Ustadzah Desi NurHalizah"],
        },
        {
            role: "Bendahara",
            names: ["Ustadz Ragil Adi Prayogo"],
        },
    ],
    units: [
        {
            role: "PPTQ Baitul Haq Putri",
            names: ["Usth. Nala Luffa Sahila, S.Pd"],
        },
        {
            role: "SQA Putra & Putri",
            names: ["Ustzh. Syifa Melati Ramadani, S.H"],
        },
        {
            role: "PPTQ Baitul Haq Putra",
            names: ["Ust. Mudzaki Syaja'ah, S.Sos"],
        },
    ],
};

export const PROGRAMS = {
    eyebrow: "Program Unggulan",
    title: "Program Pendidikan Kami",
    subtitle:
        "Membangun Generasi Qur’ani yang Mutqin, Berakhlak Mulia, dan Siap Memimpin Peradaban.",
    items: [
        {
            number: "01",
            key: "tahsin",
            title: "Tahsin Al-Qur’an",
            label: "Tahsin",
            description:
                "Perbaikan kualitas bacaan Al-Qur’an yang belum layak untuk menghafal. Metode yang digunakan adalah Talaqqi dan Tilawah.",
        },
        {
            number: "02",
            key: "tahfidz",
            title: "Tahfidz (Ziyadah & Mutqin)",
            label: "Tahfidz",
            description:
                "Fokus menambah hafalan baru mulai dari Juz 1 hingga Juz 30 serta Muroja’ah hafalan yang sudah disetorkan secara teratur.",
            method: "Metode STMJ — Setoran Terus Muroja’ah Jalan.",
            target:
                "Target: santri mampu mentasmikan hafalan Al-Qur’an 30 Juz bil ghoib dalam satu kali duduk.",
        },
        {
            number: "03",
            key: "sanad",
            title: "Sanad Al-Qur’an",
            label: "Sanad",
            description:
                "Membaca dengan sempurna bacaan Al-Qur’an 30 Juz bil ghoib secara mutqin di hadapan Muhafidzoh Pengampu untuk mendapatkan sanad guru-guru Al-Qur’an yang bersambung sampai Rasulullah SAW.",
        },
    ],
};

export const SUPPORTING = {
    eyebrow: "Program Penunjang",
    title: "Penguatan Ilmu, Adab, dan Karakter",
    items: [
        {
            icon: PenLine,
            title: "Tahfizh",
            description:
                "Ditunjang dengan Metode KATABA menulis ayat Al-Qur’an dengan tulisan tangan.",
        },
        {
            icon: AudioLines,
            title: "Qiro’atul Qur’an",
            description:
                "Memperindah bacaan Al-Qur’an dengan mempelajari berbagai irama atau lagu seperti Bayati, Rost, Nahawan, Kurdi, dan lainnya.",
        },
        {
            icon: Languages,
            title: "Bahasa Arab",
            description:
                "Pembelajaran Bahasa Arab dengan Kitab Arabiyah Baina Yadaik dan Kitab Nahwu Shorof Metode Manhaji.",
        },
        {
            icon: BookOpen,
            title: "Ulumul Syar’i",
            description:
                "Pembelajaran ilmu syariah yang mencakup Fiqh, Hadist, Siroh Nabawiyyah & Shahabiyah, dan Tadabbur Qur’an.",
        },
        {
            icon: HeartHandshake,
            title: "Pembentukan Akhlak & Adab",
            description:
                "Mempelajari Kitab Ta’limul Muta’alim dan Kitab At-Tibyan dengan fokus adab sebelum menuntut ilmu dan adab para penghafal Al-Qur’an.",
        },
        {
            icon: Compass,
            title: "Pembinaan Karakter",
            description:
                "Sebagai penguat identitas PPTQ Baitul HAQ dengan fokus disiplin, tanggung jawab, kemandirian, kepemimpinan, adab, dan kepedulian.",
        },
    ],
};

export const FORMAL = {
    eyebrow: "Jenjang Pendidikan",
    title: "SMP dan SMA/Sederajat",
    note: "Jenjang pendidikan SMP dan SMA merupakan bagian pendukung dalam perjalanan pendidikan santri.",
    items: [
        {
            title: "SMP",
            phase: "Fase Eksplorasi & Pengenalan Potensi",
            paragraphs: [
                "Masa SMP menjadi tahap untuk mengenali diri, mengeksplorasi minat dan bakat, serta memperluas pengalaman belajar dan wawasan santri.",
                "Dari proses tersebut, santri mulai menemukan potensi, kecenderungan, dan bidang yang sesuai sebagai dasar untuk menentukan arah pendidikan di jenjang SMA.",
            ],
        },
        {
            title: "SMA",
            phase: "Fase Penentuan & Pendalaman Arah",
            paragraphs: [
                "Memasuki jenjang SMA, santri mulai menentukan arah berdasarkan potensi, minat, bakat, dan tujuan masa depannya.",
                "Proses pendidikan kemudian diarahkan pada pendalaman bidang, penguatan kompetensi, serta persiapan menuju studi lanjut dan cita-cita yang ingin dicapai.",
            ],
        },
    ],
};

export const FACILITIES = {
    eyebrow: "Fasilitas Unggulan",
    title: "Fasilitas Terbaik Kami",
    sub: "Menunjang kebutuhan belajar, ibadah, dan pembinaan santri dalam keseharian di PPTQ Baitul Haq.",
    items: [
        {
            icon: BedDouble,
            title: "Asrama Santri",
            description:
                "Asrama putra dan putri disediakan terpisah dalam lingkungan yang nyaman dan tertata, menjadi tempat santri belajar, beribadah, beristirahat, dan menjalani pembinaan sehari-hari.",
        },
        {
            icon: MoonStar,
            title: "Musholla",
            description:
                "Musholla sebagai pusat kegiatan ibadah dan pembelajaran Al-Qur’an.",
        },
        {
            icon: Landmark,
            title: "Aula Bersama",
            description:
                "Sarana berkumpulnya santri untuk acara, kajian, dan kegiatan bersama.",
        },
        {
            icon: School,
            title: "Ruang Kelas",
            description:
                "Lingkungan belajar yang nyaman untuk jenjang pendidikan dan kajian kitab.",
        },
        {
            icon: Store,
            title: "Koperasi Santri",
            description: "Pusat penyedia kebutuhan sehari-hari santri.",
        },
        {
            icon: UtensilsCrossed,
            title: "Ruang Makan",
            description:
                "Tempat kebersamaan santri saat menikmati hidangan bersama.",
        },
        {
            icon: Dumbbell,
            title: "Lapangan & Area Olahraga",
            description:
                "Ruang untuk aktivitas fisik, olahraga, dan kegiatan luar ruang santri.",
        },
        {
            icon: LibraryBig,
            title: "Perpustakaan",
            description:
                "Sarana bagi santri untuk membaca, menuntut ilmu, dan memperluas cakrawala pengetahuan.",
        },
    ],
};

export const GALLERY = {
    eyebrow: "Galeri",
    title: "Galeri Kegiatan",
    placeholder: "Foto akan segera ditambahkan",
    categories: [
        { title: "Kegiatan Tahfizh Putra", image: "/assets/kegiatan/halaqoh-tahfizh-putra.jpeg" },
        { title: "Kegiatan Tahfizh Putri", image: "/assets/kegiatan/halaqoh-tahfizh-putri.jpeg" },
        { title: "Kegiatan Tahsin Putri", image: "/assets/kegiatan/halaqoh-tahsin-putri.jpeg" },
        { title: "Kegiatan Tahsin Putra", image: "/assets/kegiatan/halaqoh-tahsin-putra.jpeg" },
        { title: "SQA Putri", image: "/assets/kegiatan/sqa-putri.jpeg" },
        { title: "Kegiatan Belajar Santri", image: "/assets/kegiatan/kegiatan-santri.jpeg" },
    ],
};

export const REGISTRATION = {
    eyebrow: "PENDAFTARAN",
    title: "Jalur pendaftaran santri PPTQ Baitul Haq",
    tracks: [
        {
            key: "sma",
            title: "PENDAFTARAN",
            description:
                "Jalur pendaftaran santri baru PPTQ Baitul Haq.",
        },
        {
            key: "beasiswa",
            title: "Beasiswa",
            badge: "Beasiswa Penuh",
            description: "Beasiswa di peruntukkan bagi yg memenuhi syarat.",
        },
    ],
    formCta: "Isi Formulir Pendaftaran",
    waCta: "Tanya via WhatsApp",
};

export const MAIN_CTA = {
    title: "Wujudkan Cita-Cita Hafizh Berakhlak Mulia",
    subtitle: "Bersama PPTQ BAITUL HAQ TRENGGALEK",
    button: "Daftar Sekarang",
};

export const CONTACT = {
    eyebrow: "Kontak",
    title: "Hubungi Kami",
    address:
        "PPTQ Baitul Haq — RT 02 RW 01 Ds Sukorame, Kec. Gandusari, Kab. Trenggalek, Jawa Timur.",
};

export const SOCIALS = [
    {
        icon: Youtube,
        label: "YouTube",
        href: "https://www.youtube.com/@baitulhaqtglk",
    },
    {
        icon: Facebook,
        label: "Facebook",
        href: "https://web.facebook.com/profile.php?id=100088039913279",
    },
    {
        icon: Instagram,
        label: "Instagram",
        href: "https://www.instagram.com/pptqbaitulhaqtrenggalek",
    },
    {
        icon: MessageCircle,
        label: "WhatsApp",
        href: "https://api.whatsapp.com/send/?phone=6282139346623",
    },
];
